import { render } from "./SupportChatLauncher.vue?vue&type=template&id=3ededa80&scoped=true"
import script from "./SupportChatLauncher.vue?vue&type=script&lang=js"
export * from "./SupportChatLauncher.vue?vue&type=script&lang=js"

import "./SupportChatLauncher.vue?vue&type=style&index=0&id=3ededa80&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ededa80"]])

export default __exports__